var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DistributorMap'),_c('AttachmentSection',{attrs:{"files":_vm.files}}),_c('InformationSection',{attrs:{"sections":_vm.information}}),_c('ServiceTabs',{attrs:{"items":_vm.services,"title":"Distributor services"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }